/**
 * Created by sivanh on 12/12/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/userEditMaxConversationsCustomView.tmpl");
    var InputField = require("ui/input-field/InputField");

    var UserEditMaxConversationsCustomView = {};

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        UserEditMaxConversationsCustomView = Marionette.ItemView.extend({
            template: template,
            className: "max-conv-custom-settings-container",
            ui: {
                customSettingContainer: ".max-conversation-custom-container",
                maxConversationInputContainer: ".max-conversations-custom-input"
            },
            uiComponents: {
                maxConversations: {
                    type: InputField,
                    options: {
                        el: "view.ui.maxConversationInputContainer",
                        permutation: InputField.Permutation.B,
                        inputType: InputField.prototype.InputTypeEnum.numbersBetweenMinToMax,
                        range: { min: 0, max: 999 },
                        placeholder: LE.translator.translate('LEUserManagement.userEdit.maxConversations.customSetting.placeholderText')
                    },
                    events: {
                        change: "_onMaxConversationsChange"
                    }
                }
            },

            initialize: function (options) {
                this.channel = options.channel;
                this.model = options.model;
            },

            onRender: function () {
                var userMaxConversation = this.model.getMaxConversations();
                if (!_.isNull(userMaxConversation)) {
                    this.uiComponents.maxConversations.setValue(userMaxConversation);
                }
                else{
                    this.uiComponents.maxConversations.setValue('');
                }
            },

            clearCustomConfigurationInputField: function() {
                this.uiComponents.maxConversations.setValue('');
            },

            showCustomConfigurationInputField: function (show){
                this.ui.customSettingContainer.toggleClass("hide", !show);
            },

            onClose: function() {
                LEUserManagement.logger.debug("onClose", "CustomSettingsMaxConversationsView:onClose");
            },

            _onMaxConversationsChange: function(componentId, eventName, maxConversations){
                this.channel.trigger("user:change:maxConversations", maxConversations);
            }

        });
    });
    return UserEditMaxConversationsCustomView;
});
